import { trakrefFontFamilySemiBold } from "../../utils";
import { Grey3 } from "../../color_utils"
import Enums from "../../enums";

export const mapAndSort = (arr, mapOnly = false) => {
    if (mapOnly) {
        return arr.map(l => ({ value: l.id, label: l.name }));
    }
    return arr
        .map(l => ({ value: l.id, label: l.name }))
        .sort((a, b) => a.label.localeCompare(b.label));
};

export const mapAndSortLocation = (arr, mapOnly = false) => {
    if (mapOnly) {
        return arr.map(l => ({ value: l.id, label: l.name, state : l.physicalState, country: l.physicalCountry }));
    }
    return arr
        .map(l => ({ value: l.id, label: l.name, state: l.physicalState, country: l.physicalCountry }))
        .sort((a, b) => a.label.localeCompare(b.label));
};

export const mapAndSortBySpecificKey = (arr, keyToSortBy) => {
    return arr
        .map(l => ({ value: l.id, label: l[`${keyToSortBy}`] }))
        .sort((a, b) => a.label.localeCompare(b.label));
};

export const generateLifeTimeNmberRange = async () => {
    const arr = [];
    for (let i = 1; i <= 50; i++) {
        arr.push({ value: `${i}`, label: `${i}` });
    }
    return arr;
};

export const generateYearRange = async () => {
    const years = [];
    const current_year = new Date().getFullYear()
    for (let i = current_year; i >= current_year - 52; i--) {
        years.push({ value: `${i}`, label: `${i}` });
    }
    return years;
};

export const max_gas_capacity_options = [
    { value: 4.4, label: "4.4 lbs." },
    { value: 5, label: "5 lbs." },
    { value: 9, label: "9 lbs." },
    { value: 10, label: "10 lbs." },
    { value: 12, label: "12 lbs." },
    { value: 13, label: "13 lbs." },
    { value: 15, label: "15 lbs." },
    { value: 20, label: "20 lbs." },
    { value: 23, label: "23 lbs." },
    { value: 24, label: "24 lbs." },
    { value: 25, label: "25 lbs." },
    { value: 26, label: "26 lbs." },
    { value: 27, label: "27 lbs." },
    { value: 28, label: "28 lbs." },
    { value: 30, label: "30 lbs." },
    { value: 40, label: "40 lbs." },
    { value: 50, label: "50 lbs." },
    { value: 60, label: "60 lbs." },
    { value: 70, label: "70 lbs." },
    { value: 80, label: "80 lbs." },
    { value: 82, label: "82 lbs." },
    { value: 90, label: "90 lbs." },
    { value: 95, label: "95 lbs." },
    { value: 100, label: "100 lbs." },
    { value: 110, label: "110 lbs." },
    { value: 115, label: "115 lbs." },
    { value: 125, label: "125 lbs." },
    { value: 145, label: "145 lbs." },
    { value: 150, label: "150 lbs." },
    { value: 200, label: "200 lbs." },
    { value: 250, label: "250 lbs." },
    { value: 630, label: "630 lbs." },
    { value: 650, label: "650 lbs." },
    { value: 690, label: "690 lbs." },
    { value: 800, label: "800 lbs." },
    { value: 840, label: "840 lbs." },
    { value: 850, label: "850 lbs." },
    { value: 870, label: "870 lbs." },
    { value: 925, label: "925 lbs." },
    { value: 950, label: "950 lbs." },
    { value: 1000, label: "1000 lbs." },
    { value: 1200, label: "1200 lbs." },
    { value: 1300, label: "1300 lbs." },
    { value: 1350, label: "1350 lbs." },
    { value: 1400, label: "1400 lbs." },
    { value: 1450, label: "1450 lbs." },
    { value: 1550, label: "1550 lbs." },
    { value: 1700, label: "1700 lbs." },
    { value: 1750, label: "1750 lbs." },
    { value: 1800, label: "1800 lbs." },
    { value: 2000, label: "2000 lbs." },
    { value: 2200, label: "2200 lbs." }
];

export const bought_rented_options = [
    { value: "1", label: "Bought" },
    { value: "2", label: "Rented" },
];

export const air_conditioning_options = [
    { value: "air_dryer_dehumidifier", label: "Air Dryer/Dehumidifier" },
    { value: "air_handling_unit", label: "Air Handling Unit" },
    { value: "blow_through", label: "Blow Through" },
    { value: "chiller", label: "Chiller" },
    { value: "draw_through", label: "Draw-Through" },
    { value: "multizone_split", label: "EWC/Multizone Split(Ductless)" },
    { value: "heat_pump", label: "Heat Pump" },
    { value: "other", label: "Other" },
    { value: "package_unit", label: "Package Unit" },
    { value: "rtu", label: "Roof Top Unit (RTU)" },
    { value: "split_system", label: "Split System" }
];

export const chiller_options = [
    { value: "air_cooled", label: "Air Cooled" },
    { value: "evaporative", label: "Evaporative" },
    { value: "water_cooled", label: "Water Cooled" }
];

export const comfort_cooling_options = [
    { id: 0, label: "Air Conditioning" },
    { id: 1, label: "Chiller" },
    { id: 2, label: "Other" }
];

export const system_status_options = [
    { value:10, label: "Disposed/Destroyed" },
    { value: 2, label: "Mothballed - Pending Repair All Gas Removed" },
    { value:14, label: "Moved" },
    { value: 1, label: "Normal Operation" },
    { value:13, label: "Planned Retirement" },
    { value: 8, label: "Planned Retrofit" },
    { value: 5, label: "Provisional Non-Operation" },
    { value:15, label: "Returned to Landlord" },
    { value: 9, label: "Retrofitted" },
    { value: 4, label: "Seasonal Non-Operation" },
    { value: 3, label: "Seasonal Operation" },
    { value: 6, label: "Shutdown/Retired" },
    { value:11, label: "Sold" },
    { value:7, label: "Under Repair" }
];

export const other_options = [
    { value: "air_curtain", label: "Air Curtain" },
    { value: "chilled_water_loop", label: "Chilled Water Loop" },
    { value: "data_center_cooling", label: "Data Center Cooling" },
    { value: "chiller", label: "Chiller" },
    { value: "draw_through", label: "Draw-Through" }
];

export const temp_class_options = [
    { id:1, label: "High" },
    { id: 2, label: "Medium" },
    { id:3, label: "Low" },
    { id: 4, label: "Dual Temp" },
    { id:5, label: "Other" }
];

export const oil_type_options = [
    { value: "0", label: "AB" },
    { value: "2", label: "Mineral" },
    { value: "1", label: "POE" }
];

export const getOilTypeValue = (label) => {
    const option = oil_type_options.find(o => o.label === label);
    return option ? option.value : label;
};

export const refrigeration_options = [
    { id: 37, label: "Beverage System" },
    { id: 25, label: "Cascade System" },
    { id: 35, label: "Cold Table" },
    { id: 121, label: "Data Center Cooling" },
    { id: 26, label: "High Temp" },
    { id: 24, label: "Medium Temp" },
    { id: 23, label: "Low Temp" },
    { id: 27, label: "Ultra Low Temp" },
    { id: 34, label: "Ice Cream" },
    { id: 31, label: "Medical Refrigerator" },
    { id: 33, label: "Multi Compressor Rack System" },
    { id: 36, label: "Vending Machine" }
];

export const render_logic_refrigeration_options = [3, 5, 7, 6, 9, 11];

export const data_center_cooling_options = [
    { value: 110, label: "Liquid Pump System" }
];

export const medium_temp_options = [
    { value: 109, label: "Food Prep Area" },
    { value: 42, label: "Portable" },
    { value: 41, label: "Reach In" },
    { value: 34, label: "Refrigerator" },
    { value: 40, label: "Walk In" }
];

export const low_temp_options = [
    { value: 39, label: "Ice Machine" },
    { value: 37, label: "Standalone (freezer)" },
    { value: 38, label: "Walk In Freezer" }
];

export const ultra_low_temp_options = [
    { value: 43, label: "Medical Freezer" }
];

export const medical_refrigerator_options = [
    { value: 45, label: "Reach In - Horizontal" },
    { value: 44, label: "Reach In - Vertical" }
];

export const multi_compressor_options = [
    { value: 47, label: "Low Temp" },
    { value: 46, label: "Medium Temp" }
];

export const system_type_options = [
    { value: "comfort_cooling", label: "Comfort Cooling" },
    { value: "process_cooling", label: "Process Cooling" },
    { value: "refrigeration", label: "Refrigeration" }
];

export const cylinder_status_options = [
    { id: 1, label: "Active" },
    { id: 2, label: "Destroyed" },
    { id: 3, label: "Sent to Recycling" }
];

export const asset_status_options = [
    { id: 1, label: "Active" },
    { id: 2, label: "Inactive" },
    { id: 3, label: "Decommissioned" }
];

export const septic_tank_options = [
    { value: "advantex_filter", label: "AdvanTex Filter" },
    { value: "aerobic_treatment_unit", label: "Aerobic Treatment Unit" },
    { value: "drip_irrigation", label: "Drip Irrigation" }
];

export const yes_no_options = [
    { id: 0, label: "No" },
    { id: 1, label: "Yes" },
];

export const acquisition_status_options = [
    { id: 0, label: "New" },
    { id: 1, label: "Used" },
];


export const process_cooling_extra_options_chiller = [
    { value: "air_cooled", label: "Air Cooled" },
    { value: "water_cooled", label: "Water Cooled" }
]

export const process_cooling_extra_options_low_temp = [
    { value: 114, label: "-120" },
    { value: 115, label: "-80" },
    { value: 116, label: "-60" }
]

export const backflow_preventer_type_options = [
    { value:"air_gap_seperation", label: "Air-gap Seperation" },
    { value: "atmospheric_vacuum_break", label: "Atmospheric Vacuum Breaker" },
    { value: "double_check_assembly", label: "Double Check Assembly" },
    { value: "pressure_vacuum_breaker", label: "Pressure Vacuum Breaker" },
    { value: "reduced_pressure_zone", label: "Reduced Pressure Zone" }
];

export const backflow_preventer_type_extra_options = [
    { value:"air_gap", label: "Air Gap" },
    { value: "atmospheric_vacuum_breaker", label: "Atmospheric Vacuum Breaker" },
    { value: "double_check_assembly", label: "Double Check Assembly" },
    { value: "double_check_detector", label: "Double Check Detector Assemblies" },
    { value: "double_check_valve", label: "Double Check Valve" },
    { value: "double_check_valve_assemblies", label: "Double Check Valve Assemblies" },
    { value: "other", label: "Other" },
    { value: "pressure_vacuum_breaker", label: "Pressure Vacuum Breaker" },
    { value: "reduced_pressure_principle_assemblies", label: "Reduced Pressure Principle Assemblies" },
    { value: "reduced_pressure_principle_detector_assemblies", label: "Reduced Pressure Principle Detector Assemblies" },
    { value: "reduced_pressure_zone", label: "Reduced Pressure Zone" },
    { value: "spill_resistant_vacuum_breaker", label: "Spill Resistant Vacuum Breakers" }
];

export const backflow_orientation_options =  [
    { value:"down", label: "Down" },
    { value: "horizontal", label: "Horizontal" },
    { value: "other", label: "Other" },
    { value: "up", label: "Up" },
    { value: "vertical", label: "Vertical" }
];

export const backflow_water_origin_options =  [
    { value:"municipal", label: "Municipal" },
    { value: "other", label: "Other" },
    { value: "ro_di", label: "RO/DI" },
    { value: "roof", label: "Roof" },
    { value: "well", label: "Well" }
];

export const plumbing_fixture_type_options = [
    { value:"dishwasher", label: "Dishwasher" },
    { value: "fire_spinkler", label: "Fire Sprinkler" },
    { value: "garbage_disposal", label: "Garbage Disposal" },
    { value: "ice_dispenser", label: "Ice Dispenser" },
    { value: "laundry", label: "Laundry" },
    { value: "pool", label: "Pool" },
    { value: "sink_toilets", label: "Sink/Toilets & Fixtures" }
];

export const sink_toilets_fixtures_subtype_options = [
    { value:"shower", label: "Shower" },
    { value: "sink", label: "Sink" },
    { value: "toilet", label: "Toilet" }
];

export const water_cooling_tower_options = [
    { id: 0, label: "CounterFlow" },
    { id: 1, label: "CrossFlow" },
    { id: 2, label: "Mechanical Draft" }
];

export const charge_capacity_source_type = [
    { id: 1, label: "Calculated from design docs" },
    { id: 2, label: "Charge calculator program" },
    { id: 3, label: "Manual" },
    { id: 4, label: "Midpoint of range" },
    { id: 5, label: "Nameplate" },
    { id: 6, label: "Recover the full charge and weigh back in" },
    { id: 7, label: "Sum of refrigerant charged into system" },
    { id: 8, label: "Manufacturer Data" },
];

export const water_cooling_tower_sub_options = [
    { value:"field_erected", label: "Field Erected" },
    { value: "package_type", label: "Package Type" }
];

export const mechanical_draft_type_options = [
    { value:"fan_assisted_natural_draft", label: "Fan Assisted Natural Draft" },
    { value: "forced_draft", label: "Forced Draft" },
    { value: "induced_draft", label: "Induced Draft" }
];

export const water_heater_options = [
    { id: 0, label: "Circulation Heaters" },
    { id: 1, label: "Immersion Heaters" },
    { id: 2, label: "On Demand" },
    { id: 3, label: "Tank" }
];

export const water_heater_type_options = [
    { id: 0, label: "Non - Ozone Depleting" },
    { id: 1, label: "Ozone Depleting" }
];

export const circulation_heaters_type = [
    { id: 0, label: "Direct Inline Heating" },
    { id: 1, label: "Direct Side Arm Heating" },
    { id: 2, label: "Indirect Heating" }
];

export const energy_source_type_options = [
    { id: 2, label: "Combo (Natural Gas & Oil)" },
    { id: 3, label: "Electricity" },
    { id: 5, label: "Heat Pump" },
    { id: 1, label: "Heat Pump & Electric" },
    { id: 6, label: "LPG" },
    { id: 7, label: "Microwave" },
    { id: 4, label: "Natural Gas" },
    { id: 8, label: "Oil" },
    { id: 9, label: "Other" },
];

export const phase_options = [
    { id: 1, label: "Single Phase" },
    { id: 3, label: "Three Phase" },
];

export const hertz_options = [
    { value: 50, label: "50" },
    { value: 60, label: "60" },
];

export const safety_class_options = [
    { id: 1, name: 'A1' },
    { id: 3, name: 'A2L' },
    { id: 2, name: 'A2' },
    { id: 4, name: 'A3' },
    { id: 5, name: 'B1' },
    { id: 7, name: 'B2L' },
    { id: 6, name: 'B2' },
    { id: 8, name: 'B3' },
];

export const initialErrorObjectState = {
    Location: null,
    Name: null,
    TagNumber: null,
    SerialNumber: null,
    SystemStatus: null,
    MaterialType: null,
    CurrentGasWeightLBS: null,
    ChargeCapacity: null,
    TemperatureClass: null,
    ChargeCapacityDeterminedBy: null,
    NewPurchaseAquisition: null,
    CylinderStatus: false
};

export const device_type_options = [
    { value: 4, label: "Alternate Test Method (95385(f)) Monitor" },
    { value: 1, label: "Concentration Monitor" },
    { value: 2, label: "Parametric Monitor" },
    { value: 3, label: "Self-Calibrating Conc. Monitor" },
];

export const ald_type_options = [
    { value: 2, label: "Direct ALD" },
    { value: 1, label: "Indirect (parametric) ALD" },
];

export const concentration_monitor_type_options = [
    { value: 1, label: "Distributed inlets or sensors with computer readout" },
    { value: 2, label: "Distributed inlets with central analyzer and readout panel" },
    { value: 3, label: "Distributed sensors with central readout panel" },
    { value: 4, label: "Distributed sensors without central station readout" },
    { value: 5, label: "Self-calibrating monitor" },
];

export const sensor_type_options = [
    { value: 2, label: "CMOS" },
    { value: 3, label: "Corona Discharge" },
    { value: 4, label: "Electro Chemical" },
    { value: 5, label: "Heated Diode" },
    { value: 6, label: "Infared" },
    { value: 1, label: "Manual" },
    { value: 7, label: "NDIR" },
    { value: 8, label: "Open Path" },
    { value: 9, label: "Solid State" },
    { value: 10, label: "Ultraviolet" },
];

export const monitor_status_options = [
    { value: 1, label: "Primary Monitor" },
    { value: 2, label: "Secondary Monitor" }
];

export const initialCylinderState = {
    open: true,
    id: 0,
    newPurchaseAquisition: "",
    location: "",
    subLocation: "",
    assetStatus: 1,
    tagNumber: "",
    serialNumber: "",
    acquisitionDate: "",
    materialType: "",
    materialStatus: "",
    cylinderStatus: 1,
    currentGasWeightLBS: 0,
    maxGasCapacity: 0,
    regulatedAssets: [],
};

export const editCylinderRequiredFields = [
    'assetStatus',
    'materialType',
    'materialStatus',
    'cylinderStatus',
    'maxGasCapacity',
    'currentGasWeightLBS',
];

export const cylinderRequiredFields = [
    'location',
    'acquisitionDate',
    ...editCylinderRequiredFields,
];

export const cylinderTagSerialPair = ['tagNumber', 'serialNumber'];

export const EditableSystemType = [
    Enums.AssetTypes.ComfortCooling,
    Enums.AssetTypes.ProcessCooling,
    Enums.AssetTypes.Refrigeration,
];

export const cylinderLabelStyle = {
    flexShrink: 0,
    color: Grey3,
    fontSize: '13px',
    fontWeight: 600,
    fontFamily: trakrefFontFamilySemiBold,
    lineHeight: 2.5
};

export const isSubsystem = (assetType) => {
    const availableSubsystem = [
        Enums.AssetTypes.Condensor,
        Enums.AssetTypes.CompressorRack,
        Enums.AssetTypes.Evaporator,
    ]

    return availableSubsystem.some(e => e === assetType);
};

export const cylinderFieldsToIgnore = [
    'assetIdentities',
    'cylinderRequiredFields',
    'cylinderTagSerialPair',
    'displayName',
    'open',
    'regulatedAssets'
];

// These fields need to be ignored when checking for changes..
// ..to an asset because the asset details screen & the..
// ..asset edit screen share an endpoint 
export const assetFieldsToIgnore = [
    'assetIdentities',
    'applianceId',
    'assetStatusName',
    'AssetKind',
    'AssetSubType',
    'cylinderGWP',
    'backflowPreventerType',
    'assetTypeName',
    'calendarYearLeakRate',
    'coolingApplianceId',
    'createDate',
    'createdByName',
    'deviceTypeName',
    'globalWarmingPotential',
    'updateDate',
    'updatedByName',
    'userId',
    'materialClass',
    'locationName',
    'instanceId',
    'isAppliance',
    'isCoolingAppliance',
    'manufacturerName',
    'sublocationName',
    'regulatedAssetTypes',
    'RequireInstall',
    'selfContained',
    'chargeCapacityOZ',
    'currentGasWeightOZ',
    'LeakDetectionMonitorID',
    'isCylinder',
    'systemStatusName',
    'systemType',
    'locationCountry',
    'locationState',
    'isServicable',
    'id',
    'materialTypeName',
    'energySourceTypeName',
    'chargeCapacityDeterminedByName',
    'temperatureClassName',
    'leakRate',
    'leakRateName',
    'locationCity',
    'hasActiveServiceEvent',
    'assetSubTypeName',
    'safetyClassName',
];

export const selectRoundStyleSelected = {
    borderRadius: "24px",
    backgroundColor: "#9097A6CC",
    color: "white",
    padding: "0px 12px",
    width: "60%",
    "& .MuiSvgIcon-root": {
      fill: "white",
    },
    border: "1px solid #DBDADF",
    fontSize: "12px" 
};

export const selectRoundStyle = {
    borderRadius: "24px",
    backgroundColor: "#F2F2F2", 
    padding: "0px 12px",
    width: "60%",
    "& .MuiSvgIcon-root": {
        fill: "#1A173B",
    },
    border: "1px solid #706D882E",
    fontSize: "12px",
};
